import React, {Component} from 'react';
import Tag from "@amzn/meridian/tag";

export default class CartStatus extends Component {

    CART_STATUS_TO_TAG_TYPE_MAP = {
        STOW_COMPLETE: "warning",
        STOW_NOT_STARTED: "neutral",
        STOW_IN_PROGRESS: "neutral",
        MISSING: "error",
    }

    CART_STATUS_TO_DISPLAY_NAME = {
        STOW_COMPLETE: "Cart full",
        STOW_NOT_STARTED: "Available",
        STOW_IN_PROGRESS: "In progress",
        MISSING: "Cart missing",
    }

    render() {

        const status = this.props.status;

        return (
            <Tag type={this.CART_STATUS_TO_TAG_TYPE_MAP[status]}>{this.CART_STATUS_TO_DISPLAY_NAME[status]}</Tag>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/floor/CartStatus.js